import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';

import { Movie } from '@usheru-hff/shared/domain';
import { ImageService } from '@usheru-hff/shared/utils-image';

/**
 * Component to display the trDescription from a movie.
 *
 * //TODO barbeitoalex propostal - subscribe to current language to update the translate pipes
 */
@Component({
  selector: 'ush-movie-synopsis',
  templateUrl: './movie-synopsis.component.html',
  styleUrls: ['./movie-synopsis.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MovieSynopsisComponent {
  private readonly imageService = inject(ImageService);
  /**
   * @docsNotRequired
   */
  @Input()
  movie: Movie;

  portraitPlaceholder!: string;

  constructor() {
    this.portraitPlaceholder = this.imageService.portraitPlaceholder;
  }
}
